import React from 'react';
import { LogoutComponent } from '../components/views';

// No Frame: the page has its own header and footer and shows nothing that belongs to a logged in user
export default function LogoutPageLayout() {
  return <LogoutComponent />;
}
